﻿export class FreezeUI {

    static isFrozen = false;

    static Freeze = (options) => {

        if(this.isFrozen)
            return;

        const freezeHtml = document.createElement('div');
        freezeHtml.classList.add('freeze-ui');

        let parent = document.querySelector(options?.selector) || document.body;
        freezeHtml.setAttribute('data-text', options?.text || 'Please wait');
        if (document.querySelector(options?.selector)) {
            freezeHtml.style.position = 'absolute';

            this.isFrozen = true;
        }

        parent.appendChild(freezeHtml);
    };

    static UnFreeze = () => {
        let element = document.querySelector('.freeze-ui');
        if (element) {
            element.classList.add('is-unfreezing');
            setTimeout(() => {
                if (element) {
                    element.classList.remove('is-unfreezing');
                    element.parentElement?.removeChild(element);

                    this.isFrozen = false;
                }
            }, 250);
        }
    };
}
